

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import Button from "../../shared/Button"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { SRCTypeOptions, ehliyetOptions } from "../../../utils/profilimSuruculerimOptions"
import InputText from "../../shared/input/new/InputText"
import InputNumberNew from "../../shared/input/new/InputNumberNew"
import InputDate from "../../shared/input/new/InputDate"
import InputCityTown from "../../shared/input/new/InputCityTown"
import Btn from "../../shared/button/Btn"
import { clearJobListWithoutGunlukAraclar } from "../../../features/joblist/jobListSlice"
import { nanoid } from "@reduxjs/toolkit"
import InputSelectMultiple from "../../shared/input/new/InputSelectMultiple"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import InputPhoneFormatForArray from "../../shared/input/new/InputPhoneFormatForArray"
import { profilSurucuEkle } from "../../../features/companyProfile/companyProfileSlice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            .row{
                width: 100%;
                gap: 10px;
                display: flex;
                flex-direction: column;
                
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
    .flex{
        flex-direction: row !important;
    }
`

const AddProfilimSuruculerimModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmitted, setIsSubmitted] = useState(false)

    const [phoneValue, setPhoneValue] = useState("")
    const [yetkiliPhoneValue, setYetkiliPhoneValue] = useState("")

    const [data, setData] = useState({
        adSoyad: "",
        tcNo:"",
        dogum: "",
        adres: "",
    })

    const [ilIlce, setIlIlce] = useState(null)
    const [ehliyetType, setEhliyetType] = useState([])
    const [srcType, setSrcType] = useState([])

    const [referances, setReferances] = useState([
        {
            id: nanoid(),
            "firmaUnvan": "",
            "yetkiliAdSoyad": "",
            "yetkiliPhoneNumber": ""
        }
    ])
    
    const addNewReferance = () => {
        const newReferance = { "firmaUnvan": "", "yetkiliAdSoyad": "", "yetkiliPhoneNumber": "", id: nanoid()}
        setReferances([...referances, newReferance])
    }

    const deleteReferance = (id) => {
        const newList = referances.filter((item) => {
            return item.id !== id
        })
        setReferances(newList)
    }
    
    const handleChange = (e, type, nameForPhone) => {
        if(type === "referans"){
            const changeReferance = referances.map((item) => {
                if(item.id === e?.target?.name.split("/")[1]){
                    return {...item, [e?.target?.name.split("/")[0]]: e?.target?.value}
                }else{
                    return item
                }
            })
            setReferances(changeReferance)
        }else if(type === "phoneNumber"){
            const changeReferance = referances.map((item) => {
                if(item.id === nameForPhone.split("/")[1]){
                    return {...item, [nameForPhone.split("/")[0]]: e}
                }else{
                    return item
                }
            })
            setReferances(changeReferance)
        }else{
            setData((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
        }
    }

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {
        setIsSubmitted(true)
        const addData = {
            "phoneNumber": phoneValue.slice(2),
            "adSoyadUnvan": data?.adSoyad,
            "tcNo": data?.tcNo,
            "dogumTarihi": data?.dogum,
            "il": ilIlce?.city,
            "ilce": ilIlce?.town,
            "adressContent": data?.adres,
            "srcTypes": srcType?.map((item) => { return ( {srcBelgesi: item.value} ) }),
            "ehliyetTypes": ehliyetType?.map((item) => { return ( {ehliyet: item.value} ) }),
            "userReferances": referances?.map((item) => {return ({yetkiliPhoneNumber: item?.yetkiliPhoneNumber.slice(2), yetkiliAdSoyad: item?.yetkiliAdSoyad, firmaUnvan: item?.firmaUnvan})} )
        }
        dispatch(profilSurucuEkle(addData))
    }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Sürücü Ekle"}/>
        <div className="content">
            <div className="row">
                <InputPhoneFormat data={phoneValue} setData={setPhoneValue} labelText={"Telefon"} name={"phoneValue"} inputWidth={"100%"} />
            </div>

            <div className="row">
                <InputText data={data?.adSoyad} setData={(e) => handleChange(e)} labelText={"Adı Soyadı"} name={"adSoyad"} inputWidth={"100%"}/>
            </div>

            <div className="row">
                <InputNumberNew max={11} data={data?.tcNo} setData={(e) => handleChange(e)} labelText={"TC No"} name={"tcNo"} inputWidth={"100%"} />
            </div>
            <div className="row">
                <InputDate data={data?.dogum} setData={(e) => handleChange(e)} labelText={"Doğum Tarihi"} name={"dogum"} inputWidth={"100%"} />
            </div>
            
            <div className="row">
                <InputCityTown data={ilIlce?.location} setData={setIlIlce} labelText={"İl / İlçe"} name={"ilIlce"} inputWidth={"100%"} />
            </div>
            
            <div className="row">
                <InputText data={data?.adres} setData={(e) => handleChange(e)} labelText={"Adres"} name={"adres"} inputWidth={"100%"}/>
            </div>
           
            <div className="row">
                <InputSelectMultiple data={ehliyetType} setData={setEhliyetType} inputWidth={"100%"} labelText="Ehliyet" name={"ehliyetTypes"} options={ehliyetOptions}/>
            </div>
            
            <div className="row">
                <InputSelectMultiple data={srcType} setData={setSrcType} labelText={"SRC Türü"} name={"srcType"} options={SRCTypeOptions} inputWidth={"100%"} />
            </div>
            {referances?.map((item, index) => {
                const newIndex = index + 1
                return(
                    <div className="row">
                        <InputText data={item?.firmaUnvan} setData={(e) => handleChange(e, "referans")} labelText={"Referans Firma Ünvan"} name={`firmaUnvan/${item.id}`} inputWidth={"100%"}/>
                        <InputText data={item?.yetkiliAdSoyad} setData={(e) => handleChange(e, "referans")} labelText={"Referans Yetkili Ad Soyad"} name={`yetkiliAdSoyad/${item.id}`} inputWidth={"100%"}/>
                        <InputPhoneFormatForArray data={yetkiliPhoneValue} handleChange={(e) => handleChange(e, "phoneNumber", `yetkiliPhoneNumber/${item.id}`)} labelText={"Referans Yetkili Telefon Numarası"} name={`yetkiliPhoneNumber/${item.id}`} inputWidth={"100%"}/>
                        {referances?.length > 1 &&
                            <Btn bgColor={"transparent"} color={"#E85446"} width={"120px"} padding="0px 10px" handleClick={() => deleteReferance(item.id)} >{newIndex}. Referansı Sil</Btn>
                        }
                    
                    </div>
            )})}
            <div className="row">
                <Btn bgColor={"transparent"} color={"#E85446"} width={"170px"} padding="0px 10px" handleClick={addNewReferance} >Başka Referans Ekle</Btn>
            </div>

        </div>

        <div className="button-grp">
            <Btn bgColor={"#E85446"} color={"#fff"} width="280px" handleClick={handleSubmit}>Ekle</Btn>
            <Btn bgColor={"transparent"} color={"#E85446"} width="280px" handleClick={() => {dispatch(showModal(null)); dispatch(clearJobListWithoutGunlukAraclar())}}>Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddProfilimSuruculerimModal